module.exports = __webpack_public_path__ + "static/media/Brigham.84d2ac85.png";